<template>
	<div class="home_wrap">
		<div class="index_top_bg">
			<!-- 语言选择按钮 -->
			<div class="language" @click="$router.push('/language')">
				<img :src="require('../images/language/'+lang+'.png')">
				<span>{{$t('lang.curtext')}}</span>
			</div>
			<!-- 消息按钮 -->
			<div class="msg" @click="$router.push('/notice')">
				<span class="iconfont icon-xiaoxi"></span>
			</div>
		</div>
		<!-- 滚动广告横幅 -->
		<div class="index-banner">
			<swiper ref="mySwiper" :options="swiperOption">
				<swiper-slide v-for="(image, index) in data.banner" :key="index">
					<router-link :to="image.url">
						<img :src="image[lang]">
					</router-link>
				</swiper-slide>
			</swiper>
			<div class="swiper-pagination"></div>
		</div>
		<!-- 功能菜单选项 -->
		<div v-show="loading" class="work_box">
			<div class="item" @click="$router.push('/sign')">
				<div class="item_img"><img src="../images/new/index-1.png" alt=""></div>
				<p class="item_title">{{$t('index.sign')}}</p>
			</div>
			<div class="item" @click="$router.push('/myTeam')">
				<div class="item_img"><img src="../images/new/index-2.png" alt=""></div>
				<p class="item_title">{{$t('index.invite')}}</p>
			</div>
			<div class="item" @click="$router.push('/invest')">
				<div class="item_img"><img src="../images/new/index-3.png" alt=""></div>
				<p class="item_title">{{$t('index.recharge')}}</p>
			</div>
			<div class="item" @click="$router.push('/cash')">
				<div class="item_img"><img src="../images/new/index-4.png" alt=""></div>
				<p class="item_title">{{$t('index.withdraw')}}</p>
			</div>
			<div class="item" @click="$router.push('/about/8')">
				<div class="item_img"><img src="../images/new/index-5.png" alt=""></div>
				<p class="item_title">{{$t('index.risk')}}</p>
			</div>
			<div class="item" @click="$router.push('/about/13')">
				<div class="item_img"><img src="../images/new/index-6.png" alt=""></div>
				<p class="item_title">{{$t('index.secret')}}</p>
			</div>
			<div class="item" @click="$router.push('/about/12')">
				<div class="item_img"><img src="../images/new/index-7.png" alt=""></div>
				<p class="item_title">{{$t('index.agreement')}}</p>
			</div>
			<div class="item" @click="$router.push('/kefu')">
				<div class="item_img"><img src="../images/new/index-8.png" alt=""></div>
				<p class="item_title">{{$t('index.aboutUs')}}</p>
			</div>
		</div>
		<!-- 加载时显示的占位符 -->
		<div v-show="!loading" class="work_box query">
			<div v-for="i in 10" class="item">
				<div class="item_img" />
				<p class="item_title" />
			</div>
		</div>
		<!-- 广告区域 -->
		<div class="ads_box_1">
			<div class="ads_img" v-for="ad in data.ad1">
				<router-link :to="ad.url">
					<img :src="ad[lang]" alt="">
				</router-link>
			</div>
		</div>
		<!-- 主要内容区域 -->
		<div class="items-main">
			<div v-if="data.item1.show" class="items_panel items_1">
				<div class="items_header">
					<span class="tit_tip">{{$t('index.novice_tip')}}</span>
					<router-link class="tt-link" to="/item?type=1">
						<span class="tit_more">{{$t('index.more')}}</span>
					</router-link>
				</div>
				<div v-for="(i, index) in this.laarr" :key="i.id" class="item">
					<div class="item-number">{{ index + 1 }}</div>
					<div class="item_ti" @click="$router.push('/about/'+i.id)">
						<div class="item-head">
							<span class="span-title">{{ i.title }}</span>
						</div>
						<div class="item_desc" @click="$router.push('/about/'+i.id)">
							<p>{{i.content}}</p>
						</div>
					</div>
				</div>
				
			</div>
		</div>
		<!-- 新添加的 index_type=2 产品展示区 -->
				<div v-if="indexTypeTwoProducts.length" class="items">
					<!-- 若无数据则显示空状态 -->
					<van-empty v-if="indexTypeTwoProducts.length === 0" :description="$t('item.noData')" />
					<!-- 新的标题，只有在有产品数据时才显示 -->
					    <span class="notes_tit">{{ $t('index.featuredProducts') }}</span>
					<!-- 产品列表 -->
					<div v-for="product in indexTypeTwoProducts" :key="product.id">
						
						<!-- 根据条件显示产品项 -->
						<div class="item-if">
							<!-- 左侧图片部分 -->
							<template>
								<div class="l-p" @click="buy(product)">
									<img v-if="product.cover"  :src="product.cover" alt="" >
									<img v-else  :src="'https://' + product.img" alt="">
								</div>
							</template>
							<!-- 右侧文本部分 -->
							<template >
								<div class="r-p" @click="buy(product)">
									<!-- 产品名称 -->
									<div class="item_div1">
										<p>
										{{ product[lang] }}
										</p>
									</div>
									<!-- 金额 -->
									<div class="item_div2">
										<p><span>{{$t('utils.money')}}：</span>{{product.min}}</p>
									</div>
									<!-- 周期 -->
									<div class="item_div2">
										<p><span>{{$t('utils.cycle')}}：</span>{{product.day}}{{$t('utils.day')}}</p>
									</div>
									<!-- 浮动利润 -->
									<div class="item_div2">
										<p><span>{{$t('utils.FloatingProfit')}}：</span>{{product.min*1+product.rate_min*1}} - {{product.min*1+product.rate_max*1}}</p>
									</div>
									<!-- 库存数量 -->
									<div class="item_div2">
										<p><span>{{$t('utils.StockQuantity')}}：</span>{{product.stock*product.percent}}</p>
									</div>
									<!-- 租聘次数 -->
									<div class="item_div2">
										<p><span>{{$t('utils.NumberOfRentals')}}：</span>{{product.num}}</p>
									</div>
								</div>
							</template>
						</div>
					</div>
				</div>

		<!-- 投资对话框 -->
		<van-dialog v-model="show_tz" theme="round-button" @confirm="confirm" :confirmButtonText="$t('utils.confirm')">
			<div class="close-x" @click="show_tz = false">
				<van-icon name="cross" class="van-icon van-icon-cross" />
			</div>
			<div class="show-body">
		
				<div class="sw-cell">
					<!-- 产品名称 -->
					<div class="sw-label">{{ sku[lang] }}</div>
		
					<!-- 金额 -->
					<div class="sw-bar">
						<div class="flex_bd">
							<van-field :value="this.showmin" disabled />
						</div>
						<div class="ut">ZAR</div>
					</div>
		
				</div>
		
				<div class="sw-grid">
					<div class="flex_bd">
						<div class="sw-row">
							<div class="sw-info">{{$t('utils.yuji_sy')}}</div>
						</div>
						<div class="sw-row">
							<div class="sw-val text-green">{{sku.min*1+sku.rate_min*1}} - {{sku.min*1+sku.rate_max*1}} [ZAR]</div>
						</div>
					</div>
		
					<div class="sw-right">
						<div class="sw-label">ZAR</div>
						<div class="sw-lg">{{sku.day}}{{$t('utils.day')}}</div>
						<div class="sw-info">{{$t('utils.cycle')}}</div>
					</div>
				</div>
			</div>
		</van-dialog>

		<!-- 条款对话框 -->
		<van-dialog
		v-model="show_tc" 
		theme="round-button"
		@confirm="confirm"
		:confirmButtonText="$t('utils.confirm')"
		>
			<div class="close-x" @click="show_tc = false"><van-icon name="cross" /></div>
			<div class="show-tc-body">
				<div class="popup" v-html="tc_content"></div>
			</div>
		</van-dialog>
		<!-- 客服按钮 -->
		<div v-if="msg_show" class="kefu" :class="show_kefu?'show_kefu':'kefu_hide'" @click="kefu_to">
			<img class="kefu_img" src="../images/index/down.png">
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {WOW} from 'wowjs'
	import { swiper, swiperSlide } from "vue-awesome-swiper";
	import "swiper/dist/css/swiper.css";
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index"
	import axios from 'axios'
	import {
		Swipe,
		SwipeItem,
		Icon,
		Progress,
		Dialog,
		Field,
		Circle,
		Switch
	} from "vant";
	// 注册 Vant 组件
	Vue.use(Icon).use(Progress).use(Dialog).use(Field).use(Circle).use(Switch);

	export default {
		name: "Index",
		components: {
			VanSwipe: Swipe,
			VanSwipeItem: SwipeItem,
			swiper,
			swiperSlide
		},
		data() {
			return {
				lang: this.$i18n.locale || "en_us",
				show_kefu: false,
				msg_show: true,
				loading: false,
				icon: [],
				auto_close: [],
				app_url: '',
				data: {},
				show_img: false,
				show_tz: false,
				show_tc: true,
				tc_content: "",
				number: '',
				sku: [],
				indexTypeTwoProducts: [], // 添加保存 index_type=2 的产品列表
				// Swiper 配置
				swiperOption: {
					centeredSlides: true,
					slidesPerView: 'auto',
					loop: true,
					autoplay: {
						delay: 3000,
						stopOnLastSlide: false,
						disableOnInteraction: false
					},
					pagination: {
					  el: ".swiper-pagination",
					  clickable: true,
					},
				},
				wowdata: '',
				checked: true,
				laarr: [],
				lareq: { "language": this.$i18n.locale || "en_us" },
			};
		},
		created() {
			// 设置底部菜单
			this.$parent.footer('index');

			// 获取文章索引数据
			axios.post('https://c.mcfly.club/api/index/article_index', this.lareq)
			.then((res)=>{
				this.laarr = res.data.data
			});
		},
		mounted() {
			this.$nextTick(()=>{
					this.$wow.init()
				}
			)
			this.start();
			// 设置代理标识
			if(this.$router.history.current.query.agent){
				localStorage.setItem('agent', this.$router.history.current.query.agent);
			}

			var that = this;
			document.body.addEventListener("scroll", function() {
				if (!that.show_kefu) {
					return;
				}
				that.show_kefu = false;
			}, false);
			document.addEventListener('click', function(ev) {
				if (ev.target.className != 'kefu_img') {
					that.show_kefu = false;
				}
			}, false);
			// 获取用户 ID
			this.uid()
		},
		methods: {
			// 客服显示/隐藏切换
			kefu_to() {
				if (this.show_kefu) {
					this.$router.push('/kefu');
				}
				this.show_kefu = !this.show_kefu;
			},
			// 启动函数
			start() {
				Fetch('/index/int').then((r) => {
					this.data = r.data;
					this.loading = true;
					// 显示弹出的窗口内容
					if(r.data.popup.show==1){
						this.tc_content = r.data.popup.content;
						this.show_tc = true;
					}
					// 获取 index_type=2 的产品
					this.fetchIndexTypeTwoProducts();
				});
				// 获取自动关闭项目数据
				Fetch('/index/item_auto').then((r) => {
					for (var i = 0; i < r.data.ids.length; i++) {
						this.auto_close.push(parseInt(r.data.ids[i]));
					}
				});
			},
			// 获取 index_type=2 的产品数据
			fetchIndexTypeTwoProducts() {
				Fetch('/index/item_search', {
					index_type: 2,
					language: this.lang
				}).then(response => {
					this.indexTypeTwoProducts = response.data.list || [];
				});
			},
			// 更改用户自动关闭状态
			onChange(index) {
				let els = this.$refs.dian.querySelectorAll("div");
				for (let i = 0; i < els.length; i++) {
					els[i].className = "";
				}
				els[index].className = "selected";
			},
			// 购买操作
			buy(item) {
				this.sku = item;
				if (this.auto_close.indexOf(item.id) != -1) {
					this.checked = false;
				} else {
					this.checked = true;
				}
				this.showmin = item.min;
				this.show_tz = true;
			},
			// 确认投资操作
			confirm() {
				Fetch("/index/item_apply", {
					id: this.sku.id,
					money: this.showmin
				}).then(r => {
					this.$router.push("/order");
				}).catch(err => {
					this.psd_val = '';
				})
			},
			// 获取用户 ID
			uid() {
				Fetch('/user/info').then((r) => {
					this.$store.uid = r.data.uid;
				})
			}
		}
	};
</script>

<style scoped>
	.index-products {
		padding: 20px;
	}
	.product-list {
		display: flex;
		flex-wrap: wrap;
	}
	.product-item {
		width: calc(50% - 10px);
		margin: 5px;
		cursor: pointer;
		border: 1px solid #ccc;
		padding: 10px;
	}
	.product-img {
		width: 100%;
		height: 100px;
		object-fit: cover;
		margin-bottom: 10px;
	}
	.product-info {
		line-height: 1.5;
	}
</style>


<style lang="less" scoped>
	.text-green{
		color: #32a388;
	}
	.show-body {
		padding: 20px;
		font-size: 14px;
	
		.sw-label {
			margin-bottom: 10px;
			font-size: 18px;
			font-weight: bold;
	
			
		}
	
		.sw-bar {
			display: flex;
			align-items: center;
			background-color: #f5f5f5;
			padding: 10px;
			border-radius: 4px;
	
			.flex_bd {
				color: #999999;
			}
		}
	
		.sw-cell{
	
			.sw-label{
				text-align: center;
				font-weight: bold;
			}
	
			.sw-bar{
				justify-content: center;
	
				div{
	
					margin: 5px;
					font-size: 20px;
					color: #999;
					font-weight: bold;
				}
	
				.ut{
					font-weight: bold;
				}
			}
		}
	}
	.sw-grid {
		display: flex;
		align-items: flex-end;
		margin-top: 20px;
	
		.sw-row:first-child {
			margin-bottom: 25px;
		}
	
		.sw-row>div:first-child {
		}
	
		.sw-info {
			color: #999;
			font-size: 18px;
		}
	
		.sw-val.text-green {
			font-size: 20px;
			font-weight: bold;
	
		}
	}
	.sw-right{
		text-align: center;
		.sw-lg{
			font-size: 20px;
			margin-bottom: 10px;
		}
	}
	
	
	.flex_bd{
		flex: 1;
	}
	.item-progress{
		display: flex;
		align-items: center;
		background-color: #e9e9e9;
		padding:2px 5px;
		border-radius: 40px;
		/deep/ .van-progress__pivot{
			display: none;
		}
		.item-pv{
			display: block;
			line-height: 1;
			color: #e82637;
			margin-left: 10px;
		}
	}
	.items_header{
		display: flex;
		align-items: center;
		margin-bottom: 15px;
		.tt-lg{
			font-size: 16px;
		}
		.tit_tip{
			font-size: 12px;
			color: #999;
			margin-left: auto;
		}
		.tt-link{
			font-size: 12px;
			color: #999999;
			margin-left: 20px;
		}
	}
	/deep/ .van-cell{
		padding: 15px 26px;
	}
	.home_wrap {
		overflow: hidden;
		width: 100%;
		min-height: 100vh;
		background: url(../images/new/index-bg.png) center top no-repeat;
		background-size: contain;
	}
	.index_top_bg {
	    position: relative;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding:10px 16px;
	    z-index: 10;
		.language{
			display: inline-flex;
			align-items: center;
			justify-content: center;
			padding-right: 6px;
			height: 25px;
			border-radius: 25px;
			background-image: linear-gradient(to right, #ffff80 , #ffffff);
			img{
				height: 100%;
			}
		}
		.msg{
			.icon-xiaoxi{
				color: #fff;
				font-size: 18px;
			}
			img{
				height: 100%;
			}
		}
	}
    .search_box {
        width: 80%;
        height: 29px;
        background-color: #f6f6f6;
        border-radius: 17px;
        margin: 8px 40px 0 40px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 10px 0 14px;

        .fdj {
            width: 16px;
            height: 16px;
            background: url(../images/item/fdj.png) no-repeat center center;
            background-size: 100% 100%;
        }

        .search_inp {
            flex: 1;
            margin: 0 8px;
            font-size: 14px;
            color: #000000;
            line-height: 20px;
            height: 20px;
        }

        .clear_inp {
            width: 20px;
            height: 20px;
            background: url(../images/item/clear.png) no-repeat center center;
            background-size: 100% 100%;
        }
    }

	
	.work_box {
		background: #FFFFFF;
		padding: 17px 8px 4px 8px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		.item {
			width: 25%;
			text-align: center;
			margin-bottom: 10px;
			.item_img {
				width: 100%;
				border-radius: 5px;
				overflow: hidden;
				img {
					width: 52px;
					height: 52px;
				}
			}

			.item_title {
				width: 100%;
				line-height: 14px;
				font-size: 12px;
				color: #333333;
				text-align: center;
			}
		}
	}

	.work_box.query {
		.item {

			.item_img {
				border-radius: 5px;
				background: #f0f0f0;
			}

			.item_title {
				width: 100%;
				height: 14px;
				margin-left: 0;
				background: #f0f0f0;
			}
		}

	}
	.ads_box_1{
		padding: 0 14px;
		margin-top:15px;
		text-align: center;
		img{
			width: 100%;
		}
	}
	.ads_box{
		// background: rgba(255, 255, 255, 1);
		border-radius: 13px;
		display: flex;
		text-align: center;
		margin: 0 -6px;
		margin-bottom: 15px;
		.ads_img{
			flex: 1;
			padding: 0 6px;
		}
		img{
			width: 100%;
			border-radius: 5px;
		}
	}
	.items-main{
		padding: 15px;
	}
	.items_panel{
		margin-bottom: 15px;
	}
	.items_1,
	.items_3
	{
		.items_tit {
			border-radius: 5px 5px 0 0 ;
			height: 44px;
			line-height: 44px;
			font-size: 16px;
			color: rgba(0, 0, 0, .8);
			background: #FFFFFF;
			border-bottom: 1px solid #F7F7F7;
			padding: 0 14px;
			display: flex;
			justify-content: space-between;
			.tit_tip{
				display: contents;
				font-size: 12px;
				font-weight: normal;
				color: #b2b2b2;
				margin-left: 10px;
			}
			.tit_more{
				font-size: 12px;
				font-weight: normal;
				color: #b2b2b2;
				
			}
		}
		.item{
			background-color: #FFFFFF;
			border-radius: 10px;
			box-shadow: 0 0 10px rgba(0, 0, 0, .1);
		}
	}
	.items_1 {
		.item{
			padding:15px 20px;
			margin: 0 0 15px 0;
			background-image: url(../images/index/cardbg.png);
			background-position: center;
			background-size: cover;
			display: flex;
			align-items: center;
			.item-head{
				flex: 1;
				display: flex;
				align-items: center;
				justify-content: center;
			}
			.item_ti{
				text-align: center;
				margin-top: 12px;
				margin-bottom: 12px;
				width: 80%;
				.span-title{
					flex: 1;
					text-align: left;
					font-size: 18px;
					font-weight: bold;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					
				}
				.icon-rt{
					color: #eb483e;
					margin-left: 10px;
					display: flex;
					margin-left: auto;
					animation:rt 1s linear infinite
				}
				img{
					width: 26px;
					height: 26px;
					margin-right: 10px;

				}
				p{
					
					text-overflow:ellipsis;
					white-space: nowrap;
					font-weight: bold;
					font-size: 16px;
				}
			}
			.item_tit{
				text-align: center;
				margin-top: 12px;
				margin-bottom: 12px;
				padding-right: 50%;
				.span-title{
					flex: 1;
					text-align: center;
					font-size: 18px;
					font-weight: bold;
					
				}
				.icon-rt{
					color: #eb483e;
					margin-left: 10px;
					display: flex;
					margin-left: auto;
					animation:rt 1s linear infinite
				}
				img{
					width: 26px;
					height: 26px;
					margin-right: 10px;

				}
				p{
					text-overflow:ellipsis;
					white-space: nowrap;
					font-weight: bold;
					font-size: 16px;
				}
			}
			
			.item-number {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 26px; 
			height: 26px; 
			background-color: #007bff;
			color: #ffffff;
			border-radius: 50%; 
			font-size: 14px; 
			font-weight: bold; 
			margin-right: 15px; 
			}

			.item_rate{
				text-align: center;
				color: #eb483e;
				font-size: 18px;
				font-weight: bold;
			}
			.item_desc{
				display: flex;
				color: #999;
				margin-top: 20px;
				p{
					
					white-space: nowrap; 
					overflow: hidden;
					text-overflow: ellipsis; 
					margin: 0; 
				}
			}
			.item_btn{
				text-align: center;
				button{
					width: 60%;
					min-width: 60px;
					background-image: linear-gradient(to bottom right, #ed540b, #e82637);
					color: #FFFFFF;
					padding: 12px 0px;
					border-radius: 60px;
					font-size: 14px;
				}
				.item_btn_over{
					background: #999;
				}
			}
		}
	}
	.items_2 {
		.item{
			display: flex;
			align-items: center;
			width: 100%;
			padding: 0 15px;
			text-align: center;
			border-bottom: 1px solid #ECECEC;
			div{
				margin: 15px 0;
			}
			.item_rate{
				width: 20%;
				p{
					padding: 5px 0;
				}
				p:nth-child(1){
					font-weight: bold;
					font-size: 14px;
					color: #f44844;
					
				}
				p:nth-child(2){
					color: #999;
				}
			}
			.item_tit{
				text-align: left;
				width: 55%;
				p{
					overflow:hidden;
					text-overflow:ellipsis;
					white-space:nowrap;
					padding: 5px 0;
				}
				p:nth-child(1){
					font-weight: bold;
				}
				p:nth-child(2){
					color: #999;
				}
			}
			.item_btn{
				margin-left: auto;
				button{
					min-width: 60px;
					color: #f44844;
					padding: 8px;
					border-radius: 5px;
					border: 1px solid #f44844;
				}
				.item_btn_over{
					color: #999;
					border: 1px solid #999;
				}
			}
		}
	}
	.items {
			.item-if{
				margin: 10px 15px;
				box-shadow: 0 0 10px rgba(0,0,0,.1);
				border-radius: 10px;
				background: #FFFFFF;
				display: flex;
				flex-direction: column;
			}	
			.item-if div{
				margin:20px 0;
				}
					// 左边图片样式
					.l-p{
						    width: 100%;
						    display: flex;
						    align-items: center;
						    justify-content: center;
	
						img{
							width: 70%;
						}
					}
					// 右边样式
					.r-p>div {
					  width:75%;
					  }
					.r-p{
						width: 100%;
						display: flex;
						flex-direction: column;
						align-items: center;
						span{
						color: #ef5040;
						}
						p{
						    color: #ef5040;
						    text-align: left;
						    font-size: 16px;
						    font-weight: 400;
						}
							// 产品名称
						.item_div1{
							margin:5px 0;
							p{
								color: #000;
							}
						}
						.item_div2{
							margin:5px 0;

						}
					}
				
		
	}
	.circle-cell{
		display: flex;
		justify-content: center;
		position: relative;
		margin-bottom: 10px;
		// .item_rate{
		// 	margin: 0!important;
		// 	text-align: center;
		// 	width: 100%;
		// 	position: absolute;
		// 	top: 50%;
		// 	transform: translateY(-50%);
		// }
	}
	
	.popup{
		-webkit-box-flex: 1;
		-webkit-flex: 1;
		flex: 1;
		max-height: 60vh;
		padding: 26px 24px;
		overflow-y: auto;
		font-size: 14px;
		line-height: 20px;
	}
	.bs-panel{
		box-shadow: 0 0 10px rgba(0, 0, 0, .1);
		border-radius: 10px;
		background-color: #ffffff;
	}
	.index-banner{
		position: relative;
	}
	.index-banner .swiper-slide{
		width: 290px;
		height: 150px;
		transform: scale(.9);
		a {
			display: block;
			width: 100%;
			height: 100%;
		}
			
		img {
			border-radius: 6px;
			width: 100%;
		height: 150px;
			
		}
		&.swiper-slide-active{
			transform: scale(1);
		}
	}
	.swiper-pagination{
		width: 260px;
		text-align: right;
		left: 50%;
		margin-left: -130px;
		position: absolute;
		bottom: 10px;
		z-index: 22;
		
	}
	
</style>
<style>
	.swiper-pagination-bullet{
		margin: 0 2px;
		opacity: 1;
		border-radius: 4px;
		width: 18px;
		height: 4px;
		background-color: #ffffff;
	}
	.swiper-pagination-bullet-active{
		background-color: #d43e3f;
	}
	.sw-bar .van-cell{
		padding: 0;
		background-color: transparent;
	}
	.animated.infinite {
	    -webkit-animation-iteration-count: infinite;
	    animation-iteration-count: infinite;
	}
	
	.animated.duration {
	    -webkit-animation-duration: 2s;
	    animation-duration: 2s
	}
	@-webkit-keyframes bounce {
	  0%, 20%, 50%, 80%, 100% {
		-webkit-transform: translateY(0);
		transform: translateY(0);
	  }

	  40% {
		-webkit-transform: translateY(-15px);
		transform: translateY(-15px);
	  }

	  60% {
		-webkit-transform: translateY(-5px);
		transform: translateY(-5px);
	  }
	}

	@keyframes bounce {
	  0%, 20%, 50%, 80%, 100% {
		-webkit-transform: translateY(0);
		-ms-transform: translateY(0);
		transform: translateY(0);
	  }

	  40% {
		-webkit-transform: translateY(-15px);
		-ms-transform: translateY(-15px);
		transform: translateY(-15px);
	  }

	  60% {
		-webkit-transform: translateY(-5px);
		-ms-transform: translateY(-5px);
		transform: translateY(-5px);
	  }
	}
	@keyframes rt {
	  0%{
		transform: translateX(0px);
	  }
	  100% {transform: translateX(5px);}
	}
	.close-x{
		color: #999;
		position: absolute;
		right: 12px;
		top: 12px;
	}
	.close-x .van-icon{
		font-size: 20px;
	}
	.show-tc-body{
		padding: 40px 30px 20px 30px;
	}
	.show-title{
		text-align: center;
		font-size: 17px;
		color: #e82637;
		margin-bottom: 20px;
	}
	.show-cont{
		line-height: 1.8;
		padding: 0 20px;
		font-size: 14px;
	}
	.show-tc-body p:first-child{
		text-align: center;
		font-size: 17px;
		color: #e82637;
		margin-bottom: 20px;
	}
	.sw-end{
		display: flex;
		align-items: center;
		margin-top: 20px;
	}
	.notes_tit {
		line-height: 14px;
		font-size: 18px;
		padding: 0 20px;
	}
</style>
